
var mySwiper = new Swiper ('.swiper', {
    zoom: true,
    loop:true,
    allowTouchMove:false,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
})


document.addEventListener("DOMContentLoaded", function() {
  var images = document.getElementsByClassName("contentSwiper");

  for (var i = 0; i < images.length; i++) {
    images[i].addEventListener("dragstart", function(event) {
      event.preventDefault();
    });
  }
});